import { breakpoints, colorMap, font, shape, spacing, typography } from '../Tokens';
import { createWebTheme } from '../functions.web';
export default createWebTheme({
    font,
    colorMap,
    spacing,
    shape,
    typography,
    breakpoints
});
